module.exports = __webpack_public_path__ + "static/media/GABA_Post_2018.12.28.1cc3a5a6.jpg";